/** Read-only display of a stored zip. Only 6-9 digit values are reshaped, so Canadian or legacy values pass through. */
export const formatPostalCodeForDisplay = (zip?: string): string =>
    zip && /^\d{6,9}$/.test(zip) ? `${zip.slice(0, 5)}-${zip.slice(5)}` : zip ?? '';
